import * as moment from 'moment';
import { Component, HostBinding, OnInit } from '@angular/core';
import { ThemingService } from '@michelin/theme';

import { environment } from '../../environments/environment';
import { AuthService, IdentityClaims } from '@michelin/auth';
import { AuthenticationWrapperService } from '../shared/services/authentication-wrapper.service';
import { User } from '../shared/models/user';
import { Router } from '@angular/router';

const darkClassName = 'dark-mode';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  @HostBinding('class') private className = this.themingService.theme.className;

  year = moment.utc().format('YYYY');
  version = environment.version;
  title = 'web empleados mepsa';
  darkMode = this.className === darkClassName;
  user: User = null;
  userClaims: Partial<IdentityClaims> = null;

  isMobileScreen: boolean;

  constructor(
    private readonly themingService: ThemingService,
    private readonly authService: AuthService,
    public readonly authWrapperService: AuthenticationWrapperService,
    private readonly router: Router
  ) {}
  /**
   * Toggle theme
   * Light or dark
   */
  setTheme() {
    this.darkMode = !this.darkMode;
    this.className = this.themingService.display(this.darkMode ? darkClassName : '', this.darkMode);
  }
  
  /**
   * On init
   *
   */
  ngOnInit(): void {
    this.isMobileScreen = window.innerWidth <= 768;
    window.addEventListener('resize', () => {
      this.isMobileScreen = window.innerWidth <= 768;
    });


    this.authWrapperService.onLoginSuccess$.subscribe((user: User) => {
      this.userClaims = this.authService.getIdentityClaims();
    });

    if (this.authService.hasValidIdToken) {
      this.userClaims = this.authService.getIdentityClaims();
    }
  }

  /**
   * On logout
   */
  logout() {
    this.authWrapperService.logout(this.router);
  }

  /**
   * On login
   */
  login() {
    this.authWrapperService.onLoginRequired$.next();
  }
}
